import { addToDate, formatDate, getYearInNumber, setDate } from '../dates/date.utils';

export const getNextMonthFistDay = (currentDate, format = '') => {
    return formatDate(setDate({ date: 1 }, addToDate(1, 'month', currentDate)), format);
};

export const getNextYearFirstDay = (currentDate, format = '') => {
    return formatDate(setDate({ date: 1, month: 0 }, addToDate(1, 'years', currentDate)), format);
};

export const resolveStartingDate = (serverDate, coverageYear) => {
    return coverageYear > getYearInNumber(serverDate)
        ? getNextYearFirstDay(serverDate)
        : getNextMonthFistDay(serverDate);
};